// extracted by mini-css-extract-plugin
module.exports = {"animalList":"ExpiringSoon_animalList__2V5mA","linkButton":"ExpiringSoon_linkButton__2-Hbk"};